import React from "react";
import NavMenu from "./NavMenu";

const WIP:React.FC =()=>{
    return(
        <React.Fragment>
            <div style={{height:'100vh',width:'100vw'}}>
                <h1 className="text-center" style={{margin:'auto'}}>
            Work in progress
            </h1>
            </div>
        </React.Fragment>
    )
}

export default WIP